var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyMoonLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3051 33.4133C37.8179 32.8934 37.3224 32.0679 36.5879 32.1237C36.1422 32.1576 35.6919 32.1749 35.2374 32.1749C25.6959 32.1749 17.9611 24.5713 17.9611 15.1918C17.9611 12.307 18.6928 9.59015 19.9837 7.21087C20.3309 6.57087 19.7586 5.79349 19.0686 6.05037C12.6363 8.4448 8.0625 14.5646 8.0625 21.7362C8.0625 30.9946 15.6854 38.5 25.0888 38.5C29.8811 38.5 34.211 36.5506 37.3051 33.4133Z",
    fill: "#A3B6C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.862 15.6637C38.862 15.6586 38.862 15.6535 38.862 15.6484C38.862 10.6325 35.02 6.51562 30.2201 6.51562C26.6092 6.51562 23.5362 8.85023 22.2395 12.1384C21.5114 11.8229 20.7136 11.6486 19.8776 11.6486C16.4145 11.6486 13.6562 14.6165 13.6562 18.2149C13.6562 21.8134 16.4145 24.7812 19.8776 24.7812L30.231 24.7812H36.3815C38.9939 24.7812 41.0625 22.5447 41.0625 19.8482C41.0625 18.092 40.19 16.5395 38.862 15.6637Z",
    fill: "#A3B6C2",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3949 31.284C19.3387 28.2586 16.8997 25.8125 13.8854 25.8125C11.6572 25.8125 9.74299 27.15 8.874 29.0682C8.45087 28.9152 7.99515 28.8319 7.52083 28.8319C5.29388 28.8319 3.5 30.6598 3.5 32.9003C3.5 35.1409 5.29388 36.9687 7.52083 36.9687L13.8922 36.9687H17.6771C19.3805 36.9687 20.75 35.571 20.75 33.8611C20.75 32.7895 20.2132 31.8428 19.3949 31.284Z",
    fill: "#A3B6C2",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyMoonLm);
export default __webpack_public_path__ + "static/media/cloudy-moon-lm.657cf4eaefa18aa682aebcff5d83bb7b.svg";
export { ForwardRef as ReactComponent };